import React from 'react';

const DashboardIcon = (props) => {

  let {
    height,
    width,
    iconColor,
  } = props;

  return (
    <svg
    width={width ? width : '21px'} 
    height={height ? height : '19px'} 
    viewBox="0 0 26 24" 
    xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
     <g fill={iconColor}>
        <path id="dash-board" d="M20.48 3.696a1.926 1.926 0 0 0 2.65-1.776C23.13.864 22.266 0 21.21 0s-1.92.864-1.92 1.92c0 .451.163.864.422 1.19l-3.533 4.714a1.833 1.833 0 0 0-.73-.144c-.412 0-.796.134-1.113.365l-2.918-2.429a1.96 1.96 0 0 0 .192-.816c0-1.056-.864-1.92-1.92-1.92s-1.92.864-1.92 1.92c0 .403.134.787.345 1.094l-3.35 3.908A1.922 1.922 0 0 0 3.92 9.6C2.864 9.6 2 10.464 2 11.52s.864 1.92 1.92 1.92 1.92-.864 1.92-1.92c0-.403-.134-.787-.346-1.094l3.35-3.908c.26.125.538.202.846.202.412 0 .796-.134 1.113-.365l2.919 2.429a1.96 1.96 0 0 0-.192.816c0 1.056.864 1.92 1.92 1.92s1.92-.864 1.92-1.92c0-.451-.164-.864-.423-1.19l3.533-4.714zM21.21.96c.528 0 .96.432.96.96s-.432.96-.96.96a.963.963 0 0 1-.96-.96c0-.528.432-.96.96-.96zM3.93 12.48a.963.963 0 0 1-.96-.96c0-.528.432-.96.96-.96s.96.432.96.96-.432.96-.96.96zm5.76-6.72a.963.963 0 0 1-.96-.96c0-.528.432-.96.96-.96s.96.432.96.96-.432.96-.96.96zm5.76 4.8a.963.963 0 0 1-.96-.96c0-.528.432-.96.96-.96s.96.432.96.96-.432.96-.96.96zm-10.8 6.72H3.21a1.2 1.2 0 0 0-1.2 1.2V24h3.84v-5.52a1.2 1.2 0 0 0-1.2-1.2zm.24 5.76H2.97v-4.56c0-.134.105-.24.24-.24h1.44c.134 0 .24.106.24.24v4.56zm11.28-7.68h-1.44a1.2 1.2 0 0 0-1.2 1.2V24h3.84v-7.44a1.2 1.2 0 0 0-1.2-1.2zm.24 7.68h-1.92v-6.48c0-.134.105-.24.24-.24h1.44c.134 0 .24.106.24.24v6.48zm-6-9.6H8.97a1.2 1.2 0 0 0-1.2 1.2V24h3.84v-9.36a1.2 1.2 0 0 0-1.2-1.2zm.24 9.6H8.73v-8.4c0-.134.105-.24.24-.24h1.44c.134 0 .24.106.24.24v8.4zM21.93 9.6h-1.44a1.2 1.2 0 0 0-1.2 1.2V24h3.84V10.8a1.2 1.2 0 0 0-1.2-1.2zm.24 13.44h-1.92V10.8c0-.134.105-.24.24-.24h1.44c.134 0 .24.106.24.24v12.24z"/>
        </g>
    </g>
    </svg>

  );
};

export default DashboardIcon;



// WEBPACK FOOTER //
// ./src/components/Iconoclast/DashboardIcon/index.js